module.exports = __webpack_public_path__ + "static/media/spotify.9c3dc69e.svg";